import { createApi } from "../../../../utils/createApi";
import { AxiosError, AxiosResponse } from "axios";
import { handleAddImmixToAddCameraForm } from "../../../AddSite/handleAddImmixToAddCameraForm";
import { universalAPIErrorHandler } from "../../../../utils/universalAPIErrorHandler";

export const fetchAddCameraInfo = async (
  id: string,
  navigate: any,
  options?: { silent?: boolean }
): Promise<{ initial_data?: { products?: unknown[] } } | undefined> => {
  const AxiosUI = createApi(`customer/${id}/camera_onboarding_forms/`);
  const retryFunction = () => {
    fetchAddCameraInfo(id, navigate, options);
  };
  return new Promise((resolve) => {
    AxiosUI.get("").then(
      (response: AxiosResponse) => {
        // handleAddImmixToAddCameraForm(response.data);
        localStorage.setItem("addCameraInfo", JSON.stringify(response.data));
        localStorage.setItem(
          "selectedProducts",
          JSON.stringify(response.data.initial_data.products)
        );
        resolve(response.data);
      },
      (reason: AxiosError) => {
        if (options?.silent) {
          resolve(undefined);
          return;
        }

        universalAPIErrorHandler(reason, navigate, retryFunction, () => {
          alert(`${reason}`);
        });
        resolve(undefined);
      }
    );
  });
};
